﻿import DefaultApp from './defaultApp';
import ToggleTable from './components/toggleTable.vue';
import FileUpload from './components/FileUpload.vue';
import { useVuelidate } from '@vuelidate/core';
import { required, email } from '@vuelidate/validators';

const objectionApp = {
    ...DefaultApp,
    components: {
        ToggleTable,
        FileUpload
    },
    setup: () => ({ v$: useVuelidate() }),
    data() {
        return {
            ...DefaultApp.data(),
            api: '',
            postApi: '',
            codeApi: '',
            invoices: [],
            invoicechosen: '',
            codes: [],
            reason: '',
            remarks: '',
            tempFiles: [],
            uploadFiles: [],
            email: '',
            changeEmail: false,
            user: {},
            loading: false,
            sendSuccess: false
        }
    },
    validations() {
        return {
            reason: { required },
            invoicechosen: { required },
            remarks: { required },
            email: { required, email }
        }
    },
    computed: {
        multiUpload() {
            return this.$refs.fileUploadObjection.processedFiles;
        }
    },
    methods: {
        ...DefaultApp.methods,
        async init() {
            this.loading = true;
            if (sessionStorage.getItem('user') === null) {
                this.generalError = true;
            } else {
                this.user = JSON.parse(sessionStorage.getItem('user'));
                if (this.user.email) this.email = this.user.email;
            }
            let invoicesResponse = await this.fetchData({}, this.api, 'get');
            if (invoicesResponse.status === 200) {
                this.invoices = invoicesResponse.data.items;
            } else {
                this.generalError = true;
            }
            let codeResponse = await this.fetchData({}, this.codeApi, 'get');
            if (codeResponse.status === 200) {
                this.codes = codeResponse.data;
            } else {
                this.generalError = true;
            }
            this.loading = false;
        },
        async submit() {
            let isUploadValid = await this.$refs.fileUploadObjection.v$.processedFiles.$validate();
            let isValid = await this.v$.$validate();
            if (isValid && isUploadValid) {
                this.tempFiles = this.$refs.fileUploadObjection.fileIDs;
                this.uploadFiles = this.$refs.fileUploadObjection.processedFiles;
                let data = {
                    Dossiernummer: this.invoicechosen,
                    Email: this.email,
                    ProbleemCode: this.reason,
                    Opmerkingen: this.remarks,
                    BewijsstukFileIds: this.tempFiles,
                    SetEmailForContact: this.changeEmail
                }
                const response = await this.fetchData(data, this.postApi, 'post');
                if (response.status === 200) {
                    this.sendSuccess = true;
                } else {
                    this.generalError = true;
                }
            }
        }
    },
    mounted() {
        if (this.$el.parentNode.dataset.apiurl) this.api = this.$el.parentNode.dataset.apiurl;
        if (this.$el.parentNode.dataset.posturl) this.postApi = this.$el.parentNode.dataset.posturl;
        if (this.$el.parentNode.dataset.codeurl) this.codeApi = this.$el.parentNode.dataset.codeurl;
        this.init();
    }
}


export default objectionApp;
